import { computed, readonly, ref } from 'vue';
import { api } from '@/api/client';

export type SiteContext = {
  siteType:'SAAS'|'WORKSPACE';
  workspaceCode:string|null;
  companyName:string;
  websiteUrl:string;
  loginUrl:string;
  hostname:string;
  baseHostname:string;
  websiteStatus:'DRAFT'|'PUBLISHED'|'SUSPENDED';
  publicAccessMode:'FULL'|'ESSENTIAL_ONLY';
  publicWebsiteAvailable:boolean;
  showPricing:boolean;
  showWorkspaceSignup:boolean;
  showCustomerPortal:boolean;
};

const fallback:SiteContext={siteType:'SAAS',workspaceCode:null,companyName:'Pivot Logistics ERP',websiteUrl:window.location.origin,loginUrl:'/saas-admin/login',hostname:window.location.hostname,baseHostname:window.location.hostname,websiteStatus:'PUBLISHED',publicAccessMode:'FULL',publicWebsiteAvailable:true,showPricing:true,showWorkspaceSignup:true,showCustomerPortal:false};
const context=ref<SiteContext>({...fallback});
const loaded=ref(false);let pending:Promise<void>|null=null;

async function loadSiteContext(force=false):Promise<void>{
  if(loaded.value&&!force)return;if(pending&&!force)return pending;
  pending=(async()=>{try{context.value=await api.get<SiteContext>('/public/site-context');}catch{context.value={...fallback};}finally{loaded.value=true;pending=null;}})();
  return pending;
}

export function useSiteContext(){return{
  context:readonly(context),
  isWorkspaceSite:computed(()=>context.value.siteType==='WORKSPACE'),
  workspaceCode:computed(()=>context.value.workspaceCode),
  essentialAccessOnly:computed(()=>context.value.siteType==='WORKSPACE'&&(!context.value.publicWebsiteAvailable||context.value.publicAccessMode==='ESSENTIAL_ONLY')),
  loadSiteContext,
  loaded:readonly(loaded)
};}
